import React from "react";
import PropTypes from "prop-types";

import "@brainhubeu/react-carousel/lib/style.css";
import { ListElement } from "./List.styles";

const List = props => <ListElement {...props}>{props.children}</ListElement>;

List.propTypes = {
  children: PropTypes.array.isRequired,
  width: PropTypes.number,
  paddingLeft: PropTypes.number,
  paddingTop: PropTypes.number,
  paddingBottom: PropTypes.number,
  paddingRight: PropTypes.number,
};

List.defaultProps = {
  width: 1205,
  paddingLeft: 48,
  paddingTop: 50,
  paddingBottom: 50,
  paddingRight: 48,
};

export default List;
